import React from "react";
import { useSelector } from "react-redux";
import { selectAreFontsReady } from "@ff-os/pdp-shared-redux/slices/fontsSlice";
import { selectLanguage } from "@ff-os/pdp-shared-redux/slices/globalSlice";
import { Spaces } from "@ff-os/rendering-shared/coordinates";
import { PaintablesRenderer } from "@ff-os/shared-react/components/paintables-renderer/PaintablesRenderer";
import { Paintable } from "ff-canvas";
import { usePreventRenderDuringDrag } from "../../memoizations/_redux-memoization";
import styles from "./PhotoPrintPreview.module.scss";

const PhotoPrintPreviewComponent = ({ photoId, paintables, spaces }: PhotoPrintPreviewProps) => {

    const fontsReady = useSelector(selectAreFontsReady);
    const language = useSelector(selectLanguage);

    const renderer = (
        <PaintablesRenderer
            canvasClassName={styles.canvas}
            fontsReady={fontsReady}
            paintables={paintables}
            language={language}
            spaces={spaces} />
    );

    return usePreventRenderDuringDrag(renderer);
};

type PhotoPrintPreviewProps = {
    photoId: string;
    spaces: Spaces;
    paintables: Paintable[];
};

export const PhotoPrintPreview = React.memo(PhotoPrintPreviewComponent);